import m from "mithril";
export default {
    oncreate({ attrs }) {
        const { Nav } = attrs;
        document.body.addEventListener("keydown", (e) => {
            if (e && e.keyCode === 27) {
                Nav.show = false;
                m.redraw();
            }
        });
    },
    view({ attrs }) {
        const { Nav } = attrs;
        const { links, error } = attrs;
        return [
            m("article", { class: "side-nav-toggle" },
                m("a", { href: "javascript:", title: "Navigation ein-/ausblenden", onclick: () => (Nav.show = !Nav.show) },
                    m("i", { class: "fas fa-bars" }))),
            Nav.show && (m("aside", { class: "side-nav" },
                m("div", { class: "side-nav-header" },
                    m("button", { type: "button", class: "btn--link", onclick: () => (Nav.show = false) },
                        "schlie\u00DFen",
                        m("i", { class: "fas fa-times ml2" }))),
                m(Nav, { links: links, error: error }))),
            Nav.show && (m("div", { class: "side-nav-layer", onclick: () => (Nav.show = false) })),
        ];
    },
};
